"use client"

import { Box, Tab, Tabs } from "@mui/material"

export default function EvaluationTab({
	selectedType,
	setSelectedType,
	typeNames,
	items,
	alternativeText,
}) {
	return (
		<main className="min-h-screen bg-background">
			<TabsName {...{ typeNames, selectedType, setSelectedType }} />

			<TabsItem {...{ typeNames, selectedType, items, alternativeText }} />
		</main>
	)
}

const TabsName = ({ typeNames = [], selectedType, setSelectedType }) => {
	return (
		<Tabs
			value={selectedType}
			onChange={(e, newValue) => setSelectedType(newValue)}
			variant="scrollable"
			scrollButtonsDisplay="auto"
			sx={{
				bgcolor: "#f5f5f5",
				"& .MuiTab-root": {
					fontWeight: 500,
					fontSize: "1rem",
					textTransform: "none",
					minHeight: 64,
				},
			}}
		>
			{typeNames.map((type, index) => (
				<Tab
					key={type}
					label={type}
					id={`tab-${index}`}
					aria-controls={`tabpanel-${index}`}
					iconPosition="start"
				/>
			))}
		</Tabs>
	)
}

const TabsItem = ({ typeNames, selectedType, items, alternativeText }) => {
	return typeNames.map((type, index) => {
		return (
			<TabPanel key={type} value={selectedType} index={index}>
				{items?.[type]}
			</TabPanel>
		)
	})
}

function TabPanel({ children, value, index, ...other }) {
	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`tabpanel-${index}`}
			aria-labelledby={`tab-${index}`}
			{...other}
		>
			{value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
		</div>
	)
}
